import { Injectable } from '@angular/core';
import { SignalRHttpClient } from '../services/signal-r-http-client';
import { Position } from '../../units/models/position';
import { DataGrabber } from '../../units/services/data-grabber';
import {HubService} from '../services/hub.service';
import {TranslateService} from '../translate/translate.service';
import { UnitsFacade } from '../../stores/units/facades/units.facade';
import { AuthFacade } from '../../stores/auth/facades/auth.facade';
import { Unit } from '../../units/models/unit';
import { ModalService } from '../services/modal.service';
import { SocketsManagerService } from '../../sockets-manager/services';
import { CoreFacade } from 'src/app/stores/core/facades/core.facade';
import { map } from 'rxjs/operators';
import { SettingsModel } from '../models/settings.model';
import { Settings } from '../models/settings.enum';
import { LiveDataRefreshEnum } from 'src/app/settings/models/live-data-refresh.enum';

@Injectable({
  providedIn: 'root'
})
export class PositionService extends HubService {

  private _unitIds: number[];
  private _isRequestResponse: boolean;
  private _liveDataRefreshEnum = LiveDataRefreshEnum;
  
  constructor(
    protected signalRHttpClient: SignalRHttpClient,
    protected modalService: ModalService,
    protected translate: TranslateService,
    private dataGrabber: DataGrabber,
    private unitsFacade: UnitsFacade,
    protected authFacade: AuthFacade,
    protected socketsManagerService: SocketsManagerService,
    protected _coreFacade: CoreFacade
  ) {
    super('hubs/position', modalService, translate, signalRHttpClient, authFacade, socketsManagerService, _coreFacade);
    this.subscriptions.add(this.unitsFacade.getUnits$.subscribe((units: Unit[]) => this._unitIds = units?.map(u => u?.unitId)));
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this._unitIds = null;
  }

  protected onInit() {
    this._isRequestResponseMode()
    
    if (!this._isRequestResponse) {
      this.hubConnection.on('Position', (data: Position[]) => {
        if (data && Array.isArray(data)) {
          data.forEach(p => this.dataGrabber.setPositionStatus(p));
        }
        this.unitsFacade.updatePositions(data);
      });
    }
  }

  protected onConnection() {
    if (this._unitIds?.length > 0) {
      this.unitsFacade.getPositions(this._unitIds);
    }
  }

  protected onDisconnect() {
    super.onDisconnect();
    this._unitIds = null;
  }

  private _isRequestResponseMode() {
    this.subscriptions.add(
      this._coreFacade.getSettings$.pipe(
        map((personalSettings: SettingsModel[]) => {
          const setting = personalSettings?.find(setting => setting.key === Settings.TeagleLiveDataRefresh);
          return setting?.value === this._liveDataRefreshEnum.RequestResponse;
        })
      ).subscribe(isRequestResponse => this._isRequestResponse = isRequestResponse)
    )
  }
}
